import { createFileRoute, useParams } from "@tanstack/react-router";
import { DashboardPage } from "../components/dashboards/DashboardPage";

/** A dashboard (BUILD_SPEC §16.5): its gadgets, each answering its viewer as them. */
function Page() {
  const { dashboardId } = useParams({ from: "/admin/dashboards/$dashboardId" });
  return <DashboardPage key={dashboardId} dashboardId={dashboardId} />;
}

export const Route = createFileRoute("/admin/dashboards/$dashboardId")({ component: Page });
